/**
 * 由于控制台要求页面整体铺满屏幕，只有内容区域竖向滚动，这就要求页面中大部分区域都需要纵向固定高度
 * 为了保证项目中不出现过多的 flex 布局，因此最好将纵向布局的元素高度设为定值
 */
export default {
  // 为了保险起见，在元素插入父节点时也调用一次
  inserted(el, { value }) {
    el.style.height = typeof value === 'number' ? value + 'px' : value;
  },
  update(el, { value }) {
    el.style.height = typeof value === 'number' ? value + 'px' : value;
  }
};
